import { useYoutubeVideo } from './hooks/useYoutubeVideo';
import { PlayIcon } from 'shared-widget-components/src/components/Icons';
import { TextWithContentModel } from '../../model/TextWithContentModel';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';

interface YoutubePreviewProps {
  content: TextWithContentModel;
  languageCode: string;
}

export const YoutubePreview = ({ content, languageCode }: YoutubePreviewProps) => {
  const { isVideoLoaded, thumbnailUrl, handleVideoLoad, videoSrc } = useYoutubeVideo({ content, languageCode });

  // @ts-ignore
  const isAdmin = window.isAdminPage;

  if (content.mediaType !== 1) return null;
  return (
    <div className='youtube w-full md:w-1/2 min-[350px]:px-5 sm:px-0'>
      {isVideoLoaded === false && (
        <div className='flex justify-center items-center min-[350px]:h-[340px] md:h-[300px] lg:h-[350px] w-full sm:w-[80%] mx-auto md:w-full relative'>
          <CDNImage src={thumbnailUrl} alt='' mobileWidth={440} imageWidth={620} imageHeight={350} fit='crop' />
          <button disabled={isAdmin} type='button' className='z-10 cursor-pointer absolute top-auto left-auto' onClick={handleVideoLoad}>
            <PlayIcon />
          </button>
        </div>
      )}
      {isVideoLoaded === true && <iframe src={videoSrc} className='min-[350px]:h-[340px] md:h-[300px] lg:h-[350px] w-full sm:w-[80%] mx-auto md:w-full' title='YouTube video player'></iframe>}
    </div>
  );
};
